module.exports = __webpack_public_path__ + "img/清洗台账.4a80cfe1.png";